// extracted by mini-css-extract-plugin
export default {"pop-view":"PopView_pop-view__7zRtR","pop-img":"PopView_pop-img__JXfpF","pop-close":"PopView_pop-close__OAlTz"};